module.exports = __webpack_public_path__ + "img/moh-logo.ceb9d7da.png";